/**
 * These roles can be directly copy pasted from the endpoint /admin/metadata
 */
export const UserRoles = {
  ADMIN: "Admin",
  SE_MANAGER: "SeManager",
  SALES_ENGINEER: "SalesEngineer",
  PROSPECT_USER: "ProspectUser"
};
